var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    class: [{
      loaded: _vm.loaded
    }, 'sm-md:mt-0' /*, 'pt-32 sm-md:pt-20'*/]
  }, [_c('loading-overlay', {
    attrs: {
      "tracking": {
        class: 'app-download',
        subclass: 'page'
      }
    },
    model: {
      value: _vm.loaded,
      callback: function ($$v) {
        _vm.loaded = $$v;
      },
      expression: "loaded"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "out-in"
    }
  }, [_c('section', {
    staticClass: "dash--section"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container -mt-6 section--content"
  }, [_c('div', {
    staticClass: "flex flex-col items-center w-full"
  }, [_c('div', {
    staticClass: "max-w-4xl -mt-2 -mb-24 video-container sm-md:-mx-40"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/download_hero.jpg"),
      "alt": "Mobile views of the Extra App"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "mb-2 text-5xl font-medium leading-tight tracking-wide text-center fade-in-1 font-display sm-md:text-3xl"
  }, [_vm._v("\n\t\t\t\t\t\t\tVerify your address in the Extra App.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "mt-4 mb-4 text-xl font-normal leading-10 tracking-wider text-center uppercase fade-in-2 font-display sm-md:text-xl sm-md:leading-7 sm-md:mt-2 sm-md:mb-0 sm-md:px-8"
  }, [_vm._v("\n\t\t\t\t\t\t\tScan the QR code or open your Extra App to verify.\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "mt-5 mb-12"
  }, [_c('download-badges', {
    attrs: {
      "download-url": "https://links.extra.app/verify-address"
    }
  })], 1)]), _vm._v(" "), _c('links-footer', {
    staticClass: "justify-center fade-in-4"
  })], 1)])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };